import { render, staticRenderFns } from "./MenuItems.vue?vue&type=template&id=d5794e86&scoped=true&"
import script from "./MenuItems.vue?vue&type=script&lang=js&"
export * from "./MenuItems.vue?vue&type=script&lang=js&"
import style0 from "./MenuItems.vue?vue&type=style&index=0&id=d5794e86&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5794e86",
  null
  
)

export default component.exports